import * as React from "react";
import { WhitelabelSettings } from "kmmp";
import { SignatureJerseyPackageType, SignatureJerseyFrame } from "kmmp/frontend";
import { getSignatureJerseyImage } from "client/image-urls";
import { PublicImage } from "client/components/public-image";

interface IProps extends React.Props<any> {
    packageType: SignatureJerseyPackageType;
    frame: SignatureJerseyFrame;
    whitelabelSettings: WhitelabelSettings;
    displayAsPackage: boolean;
}

export function SignatureJerseyPreview(props: IProps): JSX.Element {
    const src = getSignatureJerseyImage(props.packageType, props.frame);
    return <PublicImage className="img-responsive" style={{ objectFit: "contain" }} src={src} alt={"Package preview"} />;
}
